var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 10.0001H45C46.3261 10.0001 47.5978 10.5269 48.5355 11.4646C49.4732 12.4023 50 13.674 50 15.0001V50.0001C50 51.3262 49.4732 52.598 48.5355 53.5357C47.5978 54.4733 46.3261 55.0001 45 55.0001H15C13.6739 55.0001 12.4021 54.4733 11.4645 53.5357C10.5268 52.598 10 51.3262 10 50.0001V15.0001C10 13.674 10.5268 12.4023 11.4645 11.4646C12.4021 10.5269 13.6739 10.0001 15 10.0001H20",
    stroke: "#3F7DBC",
    strokeWidth: 4.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 4.99994H22.5C21.1193 4.99994 20 6.11923 20 7.49994V12.4999C20 13.8807 21.1193 14.9999 22.5 14.9999H37.5C38.8807 14.9999 40 13.8807 40 12.4999V7.49994C40 6.11923 38.8807 4.99994 37.5 4.99994Z",
    stroke: "#3F7DBC",
    strokeWidth: 4.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsLg);
export default __webpack_public_path__ + "static/media/NewsLg.90494a5d8c440796cb0dfe708293993c.svg";
export { ForwardRef as ReactComponent };